import PropTypes from 'prop-types';

export const MoldReceiving = {
  CustomerId: PropTypes.number,
  toolID: PropTypes.string,
  customerName: PropTypes.string,
  customerContact: PropTypes.string,
  customerEmail: PropTypes.string,
  customerPhone: PropTypes.string,
  moldNumber: PropTypes.string,
  moldDescription: PropTypes.string,
  partID: PropTypes.number,
 // partNumber: PropTypes.string,
  materialType: PropTypes.string,
  cavity: PropTypes.string,
  shipmentDate: PropTypes.string,
  receivedDate: PropTypes.string,
  carrier: PropTypes.string,
  trackingNumber: PropTypes.string,
  conditionofShipment: PropTypes.string,
  inspectedBy: PropTypes.string,
  visualInspectionDamage: PropTypes.bool,
  visualInspectionRust: PropTypes.bool,
  visualInspectionLabeling: PropTypes.bool,
  moldWidth: PropTypes.number,
  moldHeight: PropTypes.number,
  moldLength: PropTypes.number,
  functionalTestResult: PropTypes.bool,
  functionalTestPicture: PropTypes.string,
  additionalComments: PropTypes.string,
  unloadingApproval: PropTypes.string,
  qualityControlApprovedBy: PropTypes.string,
  engineeringApprovedBy: PropTypes.string,
  submittedBy: PropTypes.string,
  moldDocuments: PropTypes.object,
};

// export const ShippingDocuments = {
//   id: PropTypes.number,
//   fileCategoryId: PropTypes.number,
//   fileCategory: PropTypes.string,
//   filePath: PropTypes.string,
//   fileName: PropTypes.string,
// };
